import { ConvexReactClient } from "convex/react";
import { ReactNode, useMemo } from "react";
import { ConvexAuthProvider } from "@convex-dev/auth/react";
import { ConvexQueryCacheProvider } from "convex-helpers/react/cache/provider";
import { api } from "@repo/convex/convex/_generated/api";

export function ConvexClientProvider({ children, url }: { children: ReactNode; url: string }) {
  const client = useMemo(() => {
    console.log(`Creating ConvexReactClient with url: ${url}`);
    return new ConvexReactClient(url);
  }, [url]);

  // Convex Auth v2 keeps the session in localStorage and refreshes it through these two. It also
  // finishes an Apple or Google sign-in when the page loads with the code they send back.
  return (
    <ConvexAuthProvider
      client={client}
      api={{ refreshSession: api.auth.refreshSession, signOut: api.auth.signOut }}
    >
      <ConvexQueryCacheProvider>{children}</ConvexQueryCacheProvider>
    </ConvexAuthProvider>
  );
}
